/** @jsx jsx */

import { jsx } from '@emotion/core';
import { Fragment } from 'react';

import { Margin, Spinner, Text } from '@zapier/design-system';

import { Delay } from './Delay';

export const ChangePlanIndicator = () => (
  <Fragment>
    <Spinner />

    <Delay delay={2000}>
      <Margin margin="10px 0 0 0">
        <Text type="smallPrint1">
          A few seconds more. We're cooking your awesome new plan!
        </Text>
      </Margin>
    </Delay>
  </Fragment>
);
